import { FC } from 'react'

import styled from 'styled-components'

import { PrimarySkeleton } from 'src/Components/Skeletons/PrimarySkeleton'
import { device } from 'src/Styled/variables'

const TabsRow = styled.div`
  display: flex;
  border-bottom: 2px solid ${({ theme }) => theme.color.lightGrey};
`

const TabItem = styled(PrimarySkeleton)`
  height: 37px;
  width: 100px;
  border-radius: 4px;
`

const FormContainer = styled.div`
  margin-top: 24px;
`

const RowWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 0 0 100%;
  max-width: 100%;
  padding-right: 15px;
  margin-bottom: 16px;
  @media ${device.largeScreen} {
    flex: 0 0 50%;
    max-width: 50%;
  }
`

const InputSkeleton = styled(PrimarySkeleton)`
  height: 56px;
  border-radius: 8px;
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 16px;
`

const ButtonSkeleton = styled(PrimarySkeleton)`
  height: 40px;
  width: 144px;
  border-radius: 8px;
`

const FIELD_COUNT = 6

const fields = Array.from({ length: FIELD_COUNT }, (_, i) => i)

export const WisePayoutSkeleton: FC = () => (
  <>
    <TabsRow>
      <TabItem />
    </TabsRow>
    <FormContainer>
      <RowWrapper>
        {fields.map((i) => (
          <FieldWrapper key={i}>
            <InputSkeleton />
          </FieldWrapper>
        ))}
      </RowWrapper>
      <ButtonContainer>
        <ButtonSkeleton />
      </ButtonContainer>
    </FormContainer>
  </>
)
